import WOW from '../../js/pages/client-admin-app/wow.min.js'
import $ from "jquery";

//console.log( 'secure page' );

let $offset = 120;
if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}

$(window).resize(function() {
    if ( $(window).width() < 768) {
        $offset = 70;
    } else {
        $offset = 120;
    }
});

new WOW({
    offset: $offset
}).init();

